import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowRight, MdExpandMore } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SellerCard from "./seller-card";

const BestSellersSection = () => {
  const { categorys, sellers } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="w-full bg-primaryBackground pb-16 pt-20 sm:pt-10 sm:pb-0">
      <div className="w-[90%] mx-auto">
        <div className="flex gap-6 lg:flex-col">
          {/* Sidebar - Categories with premium look */}
          <aside className="w-[300px] flex-shrink-0 lg:hidden group">
            <div className="bg-card rounded-3xl shadow-sm border border-secondary/10 overflow-hidden sticky top-24 transition-all duration-500 hover:shadow-xl hover:shadow-secondary/5">
              <div className="bg-secondary text-textWhite px-7 py-4 flex items-center justify-between">
                <span className="font-semibold text-xl tracking-tight">
                  All Categories
                </span>
              </div>
              <ul className="py-3 max-h-[460px] overflow-y-auto no-scrollbar">
                {categorys && categorys.length > 0 ? (
                  categorys.map((c, i) => (
                    <li key={i}>
                      <Link
                        to={`/products/search?category=${encodeURIComponent(c.name)}`}
                        className="flex items-center justify-between px-4 py-2 hover:bg-primaryBackground/50 transition-all duration-300 group/item"
                      >
                        <div className="flex items-center gap-4">
                          <div className="size-14 rounded-2xl overflow-hidden bg-primarybackground shadow-sm flex items-center justify-center p-1 group-hover/item:scale-110 transition-transform duration-300">
                            <img
                              src={c.image}
                              alt={c.name}
                              className="w-full h-full object-cover rounded-xl"
                            />
                          </div>
                          <span className="text-textPrimary text-sm font-medium group-hover/item:text-secondary transition-colors truncate max-w-[150px]">
                            {c.name}
                          </span>
                        </div>
                        <MdOutlineKeyboardArrowRight className="text-2xl text-primary/50 group-hover/item:text-secondary group-hover/item:translate-x-1 transition-all duration-300" />
                      </Link>
                    </li>
                  ))
                ) : (
                  <div className="px-7 py-12 text-center">
                    <p className="text-textSecondary/40 text-sm italic">
                      No categories available
                    </p>
                  </div>
                )}
              </ul>
            </div>
          </aside>

          {/* Main Content Area */}
          <div className="flex-grow min-w-0">
            <div className="flex items-end justify-between mb-6">
              <div className="text-center flex justify-between items-center flex-col text-4xl px-3 sm:text-3xl text-primary font-bold relative">
                <h2>Best Sellers</h2>
              </div>
              <Link
                to="/sellers"
                className="flex items-center gap-2 text-secondary font-medium text-sm hover:text-primary transition-all tracking-widest group"
              >
                <span className="border-b-2 border-transparent group-hover:border-primary">
                  View All
                </span>
                <div className="size-8 bg-secondary/10 rounded-xl flex items-center justify-center group-hover:bg-secondary group-hover:text-white transition-all duration-300 group-hover:translate-x-1">
                  <MdOutlineKeyboardArrowRight className="text-xl" />
                </div>
              </Link>
            </div>

            <div className="relative">
              {sellers && sellers.length > 0 ? (
                <Carousel
                  autoPlay={false}
                  infinite={true}
                  arrows={true}
                  responsive={responsive}
                  transitionDuration={500}
                  containerClass="carousel-container"
                  itemClass="px-3"
                >
                  {sellers.map((seller, i) => (
                    <div key={i} className="h-full">
                      <SellerCard seller={seller} />
                    </div>
                  ))}
                </Carousel>
              ) : (
                <div className="py-24 text-center bg-card rounded-[40px] border-2 border-dashed border-secondary/20 mx-3">
                  <p className="text-textSecondary font-bold text-lg">
                    Best sellers are coming soon!
                  </p>
                  <p className="text-textSecondary/60 mt-2">
                    Explore our full list of sellers in the meantime.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSellersSection;
